export default {
    auth: {
        login: {
            buttons: {
                enter: 'เข้าร่วม',
                otherStudent: 'เข้าร่วมด้วยบัญชีนักเรียนคนอื่น',
                otherClassroom: 'เข้าร่วมด้วยชั้นเรียนอื่น',
                pwa: 'สร้างทางลัด',
            },
            pwa: {
                title: 'สร้างทางลัดบนหน้าจอโฮมเหมือนแอปไหม?',
                description: 'ต่อไปจะเข้าร่วมได้ทันทีโดยไม่ต้องใช้รหัสชั้นเรียน!',
                install: {
                    ios: 'กดปุ่ม "แชร์" ที่ด้านล่างของเบราว์เซอร์ Safari แล้วเลือก "เพิ่มไปยังหน้าจอโฮม"',
                    android: 'กดเมนูเบราว์เซอร์ (⋮) แล้วเลือก "ติดตั้งแอป"',
                    default: 'ในเมนูเบราว์เซอร์ เลือก "เพิ่มไปยังหน้าจอโฮม" หรือ "ติดตั้งแอป"',
                },
                buttons: {
                    next: 'ไว้ทีหลัง',
                    create: 'สร้างทางลัด',
                },
            },
            pinSet: 'ตั้งรหัส PIN แล้ว! เข้าร่วมคาบเรียนได้เลย',
            stepClassroom: {
                title: 'นักเรียนเข้าร่วม',
                description: 'กรอกรหัสชั้นเรียนที่คุณครูแชร์ให้เลย!',
            },
            stepPin: {
                studentInfo: 'เลขที่ {number} {name}',
                input: 'กรอกรหัส PIN เพื่อเข้าร่วมคาบเรียน',
                set: 'ตั้งรหัส PIN เพื่อเข้าร่วมคาบเรียน',
                retry: 'กรอกรหัส PIN อีกครั้ง',
                tip: 'ต้องใช้รหัส PIN ตอนเข้าร่วมคาบเรียน อย่าลืมจำไว้ให้ดีนะ!',
                error: {
                    confirm: 'รหัส PIN ไม่ตรงกัน! กรุณาตรวจสอบแล้วกรอกอีกครั้ง',
                    unknown: 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ',
                    pin: 'ไม่สามารถตรวจสอบรหัส PIN ได้',
                    set: 'ไม่สามารถตั้งรหัส PIN ได้',
                },
            },
            stepStudent: {
                title: 'กรอกเลขที่และชื่อกันเลย!',
                placeholder: {
                    number: 'กรอกเลขที่ (ตัวเลข)',
                    name: 'กรอกชื่อ (ภาษาเกาหลี)',
                },
                error: {
                    nameKorean: 'กรอกได้เฉพาะภาษาเกาหลีเท่านั้น',
                    number: 'กรอกได้เฉพาะตัวเลขเท่านั้น',
                    unknown: 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ',
                },
            },
        },
    },
};
